module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "giving-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/giving.svg"),
      "alt": "TONE GIVING",
      "title": "TONE Giving"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("giving")]), _vm._v(" "), _c('p', [_vm._v("\n            While we can't give you back time, we can make it easier to give back to others. This is why we created Clicks For Good. The more time you spend on TONE, the more we'll donate to the charity of your choice. Thanks for helping us out!\n        ")]), _vm._v(" "), _vm._l((_vm.getAllCharities), function(charity) {
    return _c('div', {
      key: charity.charityId
    }, [_c('div', {
      staticClass: "row givingVideos"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', [_c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": charity.img_url,
        "title": charity.name,
        "alt": charity.name
      }
    })])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6"
    }, [_c('h3', [_vm._v(_vm._s(charity.name)), _c('br'), _c('small', [_c('a', {
      staticClass: "weblink",
      attrs: {
        "target": "_new",
        "href": charity.website
      }
    }, [_vm._v(_vm._s(charity.website))])])]), _vm._v(" "), _c('p', [_vm._v("\n                       " + _vm._s(charity.description) + "\n                    ")]), _vm._v(" "), (_vm.getSelectedCharity) ? _c('div', [(_vm.checkCharity(charity) === true) ? _c('div', [_c('button', {
      staticClass: "selectedCharity",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Your Charity!")])]) : _c('div', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.changeCharity(charity)
        }
      }
    }, [_vm._v("\n                                Choose this Charity!\n                                ")])])]) : _vm._e()])])])
  })], 2), _vm._v(" "), (_vm.showModal_player) ? _c('modal', {
    attrs: {
      "effect": "zoom",
      "value": _vm.showModal_player,
      "width": "400"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal_player()
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64c5fd66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Giving.vue